import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as CommunitiesActions from './communities.actions';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../shared/services/toast.service';
import { CommunitiesService } from '../services/communities.services';
import { Router } from '@angular/router';

@Injectable()
export class CommunitiesEffects {
  private router = inject(Router);

  constructor(private actions$: Actions,
      private communitiesService: CommunitiesService,
      private toastService: ToastService,
      private translate: TranslateService) {}

  createCommunityEffect$ = createEffect(() => this.actions$.pipe(
    ofType(CommunitiesActions.createCommunity),
    switchMap((action) =>
      this.communitiesService.createCommunity(action).pipe(
        map(community => {
          this.toastService.Success(this.translate.instant("community.create.created"), '');
          this.router.navigate(['/manageCommunities']);
          return CommunitiesActions.createCommunitySuccess({community})
        }),
        catchError(() => of(CommunitiesActions.createCommunityFailure({ error: 'Invalid credentials' })))
      )
    )
  ));

  editCommunityEffect$ = createEffect(() => this.actions$.pipe(
    ofType(CommunitiesActions.editCommunity),
    switchMap((action) =>
      this.communitiesService.editCommunity(action).pipe(
        map(community => {
          this.toastService.Success(this.translate.instant("community.edit.updated"), '');
          this.router.navigate(['/manageCommunities']);
          return CommunitiesActions.editCommunitySuccess({community})
        }),
        catchError(() => of(CommunitiesActions.editCommunityFailure({ error: 'Invalid credentials' })))
      )
    )
  ));

  getCommunitiesEffect$ = createEffect(() => this.actions$.pipe(
    ofType(CommunitiesActions.getCommunities),
    switchMap(() =>
      this.communitiesService.getCommunities().pipe(
        map(communities => CommunitiesActions.getCommunitiesSuccess({communities}))
      )
    )
  ));

  // searchCommunitiesEffect$ = createEffect(() => this.actions$.pipe(
  //   ofType(CommunitiesActions.searchCommunity),
  //   switchMap((action) =>
  //     this.communitiesService.searchCommunity(action.searchCriteria).pipe(
  //       map(searchResults => CommunitiesActions.searchCommunitySentSuccess({searchResults}))
  //     )
  //   )
  // ));

  deleteCommunityEffect$ = createEffect(() => this.actions$.pipe(
      ofType(CommunitiesActions.deleteCommunity),
      switchMap((action) =>
        this.communitiesService.deleteCommunity(action.communityId).pipe(
          map(community => {
            this.toastService.Success(this.translate.instant("community.delete.deleted"), '');
            return CommunitiesActions.deleteCommunitySentSuccess({community})
          }),
          catchError(() => of(CommunitiesActions.deleteCommunitySentFailure({ error: 'Error cancelling community' })))
        )
      )
    )
  );

  // getPendingCommunitiesEffect$ = createEffect(() => this.actions$.pipe(
  //   ofType(CommunitiesActions.getPendingCommunity),
  //   switchMap(() =>
  //     this.communitiesService.getCommunityInvitations().pipe(
  //       map(communities => CommunitiesActions.getPendingCommunitySuccess({communities}))
  //     )
  //   )
  // ));

  // addTagToCommunitiesEffect$ = createEffect(() => this.actions$.pipe(
  //   ofType(CommunitiesActions.addTagToCommunity),
  //   switchMap((action) =>
  //     this.communitiesService.addTagToCommunities(action.tagId, action.selectedCommunities).pipe(
  //       map(tag => {
  //         this.toastService.show(this.translate.instant("tag.deleted"), '');
  //         return CommunitiesActions.getCommunities();
  //       }),
  //       catchError(() => of(CommunitiesActions.addTagToCommunityFailure({ error: 'Error cancelling tag' })))
  //     )
  //   )
  // ));

  // removeTagToCommunitiesEffect$ = createEffect(() => this.actions$.pipe(
  //   ofType(CommunitiesActions.removeTagToCommunity),
  //   switchMap((action) =>
  //     this.communitiesService.removeTagToCommunities(action.communityTagId).pipe(
  //       map(tag => {
  //         this.toastService.show(this.translate.instant("tag.deleted"), '');
  //         return CommunitiesActions.getCommunities();
  //       }),
  //       catchError(() => of(CommunitiesActions.removeTagToCommunityFailure({ error: 'Error cancelling tag' })))
  //     )
  //   )
  // ));
}
